module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4QoHAAwZDnWlUwAAANFJREFUWMPtl0EKAyEMRU32PVbBtfd0tg7MrXqB30URbIlap0wiVMHdaF5+MvJDANzI2jdqHvABNHIffQNQBvX3zrfHIAyA5k7RAY9zO0WH3v1VBXLWvYy76h1tNUSAfSP8GlgCkSBYI3hWUmpg1gjegmBnvFgr+5oKBEAt+Nu6vRrSrARZBfMeoBSdvvzF2zDPX7AAFsD/AvgAKm2U5hvgA2iVgLNf0yxDac+4tNAaEJ/ecK4euFoFyRmzNFpdAVGz5eaDybyj2VlFRodTsh7Pn8CkNJQ988m9AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/puyo_y.png
// module id = VrRu
// module chunks = 1